/* SHKRELI Premium · "Alpengrün" — base behaviour (all markets; loaded by snippets/at-head when the premium design is on).
   1 reveal-on-scroll (html.at-js) · 2 html.at-scrolled · 3 animated .at-acc details · 4 wrist-size engine
   5 theme-editor hooks · 6 window.SWAT
   7 header navigation dropdowns · 8 mobile drawer accordion · 9 language/country panel · 10 cart order links

   Reveal contract
   - Hidden state exists ONLY under html.at-js, which this file sets. If this file fails, nothing is hidden
     (plus the safety net in snippets/at-head.liquid).
   - [data-at-reveal]            fades in + rises 12px once, delay = var(--at-i) * 60ms.
   - [data-at-stagger]           every element child gets data-at-reveal and --at-i = 0,1,2… (max 8).
   - .at-section without any [data-at-reveal] (e.g. PDP / collection sections) is tagged automatically,
     but only when it starts below the first screen, so visible content never flickers.
     Opt out with data-at-no-reveal on the section.
   - prefers-reduced-motion: reduce → no hidden state, everything visible at once.

   Wrist-size engine for the homepage teaser (sections/at-wrist) – same maths, verdicts and storage as the
   product-page simulator in assets/at-pdp.js (sections/at-pdp-wrist):
   - Markup root: [data-at-wrist-sim] (deliberately NOT [data-at-wrist], which belongs to at-pdp.js).
     Optional data-at-wrist-case="40" fixes the case diameter.
   - localStorage "swAtWrist" = wrist circumference in cm as a plain number string (shared with the PDP);
     "swAtWristCase" = the case diameter chosen in the teaser (homepage only).
   - Maths: ratio = case mm / (circumference cm × 10 / π).
     ratio < 0.62 → "dezent" · < 0.78 → "klassisch" · otherwise "markant".
     Public: SWAT.wrist.{KEY, width, ratio, verdict, range, load, save, svg, init}. */
(function () {
  'use strict';
  var w = window, d = document, de = d.documentElement;
  var mq = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var EASE = 'cubic-bezier(.2,.6,.2,1)';
  var io = null;

  function reduced() { return !!(mq && mq.matches); }
  function show(el) { el.classList.add('is-in'); }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function isAt() { return !!(d.body && d.body.classList.contains('sw-at')); }

  /* 1 · Reveal --------------------------------------------------------------------------- */
  function injectRevealCss() {
    if (d.getElementById('at-reveal-css')) return;
    var css =
      '@media (prefers-reduced-motion: no-preference){' +
      'html.at-js body.sw-at [data-at-reveal]{opacity:0;transform:translate3d(0,12px,0);' +
      'transition:opacity .7s ' + EASE + ',transform .7s ' + EASE + ';transition-delay:calc(var(--at-i,0) * 60ms)}' +
      'html.at-js body.sw-at [data-at-reveal].is-in{opacity:1;transform:none}' +
      'html.at-js body.sw-at [data-at-reveal].at-rv-now{transition:none}' +
      '}';
    var st = d.createElement('style');
    st.id = 'at-reveal-css';
    st.appendChild(d.createTextNode(css));
    (d.head || de).appendChild(st);
  }

  function observer() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var tall = e.boundingClientRect.height > (w.innerHeight || 800) * 0.9;
        if (e.isIntersecting && (e.intersectionRatio >= 0.15 || tall)) {
          show(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: [0, 0.15], rootMargin: '0px 0px -8% 0px' });
    return io;
  }

  function stagger(root) {
    var groups = toArray(root.querySelectorAll('[data-at-stagger]'));
    if (root.matches && root.matches('[data-at-stagger]')) groups.unshift(root);
    groups.forEach(function (g) {
      var i = 0;
      toArray(g.children).forEach(function (k) {
        if (k.hidden || /^(SCRIPT|STYLE|TEMPLATE)$/.test(k.tagName)) return;
        if (!k.hasAttribute('data-at-reveal')) k.setAttribute('data-at-reveal', '');
        if (!k.style.getPropertyValue('--at-i')) k.style.setProperty('--at-i', String(Math.min(i, 8)));
        i++;
      });
    });
  }

  /* Sections of the AT layer that have no reveal markup of their own (below the first screen only).
     Children holding fixed/sticky UI (sticky bars, drawers, dialogs) are never wrapped. */
  var SKIP = 'dialog,[role="dialog"],[aria-modal],[data-at-sticky],[class*="sticky"],[class*="drawer"],[class*="modal"],[data-at-no-reveal]';
  function autoTag(root) {
    var vh = w.innerHeight || 800;
    var secs = toArray(root.querySelectorAll('.at-section'));
    if (root.matches && root.matches('.at-section')) secs.unshift(root);
    secs.forEach(function (sec) {
      if (sec.__atTagged || sec.matches(SKIP)) return;
      sec.__atTagged = true;
      if (sec.querySelector('[data-at-reveal]') || (sec.closest && sec.closest('[data-at-reveal]'))) return;
      if (sec.getBoundingClientRect().top < vh) return;
      var box = null;
      for (var j = 0; j < sec.children.length; j++) {
        if (sec.children[j].classList.contains('at-container')) { box = sec.children[j]; break; }
      }
      box = box || sec;
      var kids = toArray(box.children).filter(function (k) {
        return !k.hidden && !/^(SCRIPT|STYLE|TEMPLATE|DIALOG|LINK)$/.test(k.tagName) && !k.matches(SKIP) && !k.querySelector(SKIP);
      });
      if (!kids.length) return;
      if (kids.length > 10) {
        if (box === sec || box.querySelector(SKIP)) return;
        kids = [box];
      }
      kids.forEach(function (k, i) {
        k.setAttribute('data-at-reveal', '');
        if (!k.style.getPropertyValue('--at-i')) k.style.setProperty('--at-i', String(Math.min(i, 6)));
      });
    });
  }

  /* If the page already painted before this deferred file ran, content that is on screen and visible
     right now must not blink out: mark it revealed without a transition. */
  function painted() {
    try {
      var p = w.performance && w.performance.getEntriesByType ? w.performance.getEntriesByType('paint') : null;
      return !!(p && p.length);
    } catch (e) { return false; }
  }
  function primeVisible(els) {
    if (!painted()) return;
    var vh = w.innerHeight || 800;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0 && w.getComputedStyle(el).opacity !== '0') {
        el.classList.add('at-rv-now');
        show(el);
      }
    });
  }

  function reveal(root) {
    root = root && root.querySelectorAll ? root : d;
    if (!isAt()) return;
    stagger(root);
    autoTag(root);
    var els = toArray(root.querySelectorAll('[data-at-reveal]:not(.is-in)'));
    if (root !== d && root.matches && root.matches('[data-at-reveal]:not(.is-in)')) els.unshift(root);
    if (!de.classList.contains('at-js')) {
      primeVisible(els);
      de.classList.add('at-js');
    }
    els = els.filter(function (el) { return !el.classList.contains('is-in'); });
    if (!els.length) return;
    if (reduced() || !('IntersectionObserver' in w)) { els.forEach(show); return; }
    var o = observer();
    els.forEach(function (el) { o.observe(el); });
  }

  function revealNow(root) {
    if (!root || !root.querySelectorAll) return;
    toArray(root.querySelectorAll('[data-at-reveal]')).forEach(show);
    if (root.matches && root.matches('[data-at-reveal]')) show(root);
  }

  function onMotionChange() {
    if (reduced()) revealNow(d);
  }

  /* 2 · html.at-scrolled after 80px (passive listener + rAF) ------------------------------ */
  var ticking = false, last = null;
  function measure() {
    ticking = false;
    var s = (w.pageYOffset || de.scrollTop || 0) > 80;
    if (s !== last) { last = s; de.classList.toggle('at-scrolled', s); }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    (w.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(measure);
  }

  /* 3 · details.at-acc: height + opacity, 250ms (native toggle when reduced motion) -------- */
  function accBody(det) {
    for (var i = 0; i < det.children.length; i++) {
      if (det.children[i].classList.contains('at-acc__body')) return det.children[i];
    }
    return null;
  }
  function onAccClick(ev) {
    var sum = ev.target && ev.target.closest ? ev.target.closest('.at-acc__sum') : null;
    if (!sum) return;
    var det = sum.parentElement;
    if (!det || det.tagName !== 'DETAILS' || !det.classList.contains('at-acc') || sum !== det.firstElementChild) return;
    var body = accBody(det);
    if (!body || reduced() || !body.animate) return;
    ev.preventDefault();
    if (det.getAttribute('data-at-busy')) return;
    det.setAttribute('data-at-busy', '1');
    body.style.overflow = 'hidden';
    var anim;
    if (det.open) {
      anim = body.animate(
        [{ height: body.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: 250, easing: EASE, fill: 'forwards' }
      );
      anim.onfinish = function () { det.open = false; anim.oncancel = null; anim.cancel(); done(); };
    } else {
      det.open = true;
      anim = body.animate(
        [{ height: '0px', opacity: 0 }, { height: body.offsetHeight + 'px', opacity: 1 }],
        { duration: 250, easing: EASE }
      );
      anim.onfinish = done;
    }
    anim.oncancel = done;
    function done() { body.style.overflow = ''; det.removeAttribute('data-at-busy'); }
  }

  /* 4 · Wrist-size engine -------------------------------------------------------------------- */
  var WR = {
    KEY: 'swAtWrist',
    KEY_CASE: 'swAtWristCase',
    W_MIN: 14, W_MAX: 21, C_MIN: 28, C_MAX: 46,
    LO: 0.62, HI: 0.78,
    width: function (cm) { return cm * 10 / Math.PI; },
    ratio: function (cm, mm) { return mm / WR.width(cm); },
    verdict: function (cm, mm) {
      var r = WR.ratio(cm, mm);
      return r < WR.LO ? 'dezent' : (r < WR.HI ? 'klassisch' : 'markant');
    },
    range: function (cm) {
      var x = WR.width(cm);
      return [Math.ceil(x * WR.LO), Math.ceil(x * WR.HI) - 1];
    },
    clampW: function (v) { v = parseFloat(v); if (isNaN(v)) return null; return Math.min(WR.W_MAX, Math.max(WR.W_MIN, Math.round(v * 2) / 2)); },
    clampC: function (v) { v = parseFloat(v); if (isNaN(v)) return null; return Math.min(WR.C_MAX, Math.max(WR.C_MIN, Math.round(v))); },
    load: function () {
      try {
        return { w: WR.clampW(w.localStorage.getItem(WR.KEY)), c: WR.clampC(w.localStorage.getItem(WR.KEY_CASE)) };
      } catch (e) { return null; }
    },
    save: function (o) {
      try {
        if (o.w != null) w.localStorage.setItem(WR.KEY, String(o.w));
        if (o.c != null) w.localStorage.setItem(WR.KEY_CASE, String(o.c));
      } catch (e) { /* private mode: keep working without storage */ }
    },
    /* SVG body (viewBox 0 0 360 240): arm seen from above, strap, case with dial, two dimension lines. */
    svg: function (cm, mm, uid, labels) {
      var K = 2.4, cx = 180, cy = 120;
      var wmm = WR.width(cm), a = wmm * K / 2, R = mm * K / 2, sw = mm * 0.52 * K;
      var f = function (n) { return Math.round(n * 10) / 10; };
      var gid = 'AtWc-' + uid;
      var hx = function (deg, len) { return f(cx + len * Math.sin(deg * Math.PI / 180)); };
      var hy = function (deg, len) { return f(cy - len * Math.cos(deg * Math.PI / 180)); };
      var yT = cy - a - 24;
      var lc = (labels && labels.c) || (mm + ' mm');
      var lw = (labels && labels.w) || ('≈ ' + Math.round(wmm) + ' mm');
      return '' +
        '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="1" y2="1">' +
        '<stop offset="0" stop-color="#F4EFE3"></stop><stop offset=".5" stop-color="#E3DCCB"></stop><stop offset="1" stop-color="#A39D8F"></stop>' +
        '</linearGradient></defs>' +
        '<path class="at-wrist__arm" d="M-10 ' + f(cy - a * 1.05) + ' C110 ' + f(cy - a) + ' 250 ' + f(cy - a * 0.97) + ' 370 ' + f(cy - a * 1.03) +
        ' L370 ' + f(cy + a * 1.03) + ' C250 ' + f(cy + a * 0.97) + ' 110 ' + f(cy + a) + ' -10 ' + f(cy + a * 1.05) + ' Z"></path>' +
        '<rect class="at-wrist__strap" x="' + f(cx - sw / 2) + '" y="' + f(cy - a - 8) + '" width="' + f(sw) + '" height="' + f(2 * a + 16) + '" rx="3"></rect>' +
        '<rect class="at-wrist__crown" x="' + f(cx + R - 1.5) + '" y="' + f(cy - 4) + '" width="6" height="8" rx="1.5" fill="url(#' + gid + ')"></rect>' +
        '<circle class="at-wrist__case" cx="' + cx + '" cy="' + cy + '" r="' + f(R) + '" fill="url(#' + gid + ')"></circle>' +
        '<circle class="at-wrist__dial" cx="' + cx + '" cy="' + cy + '" r="' + f(R * 0.86) + '"></circle>' +
        '<line class="at-wrist__hand" x1="' + cx + '" y1="' + cy + '" x2="' + hx(305, R * 0.45) + '" y2="' + hy(305, R * 0.45) + '" stroke-width="' + f(Math.max(1.8, R * 0.065)) + '"></line>' +
        '<line class="at-wrist__hand" x1="' + cx + '" y1="' + cy + '" x2="' + hx(60, R * 0.7) + '" y2="' + hy(60, R * 0.7) + '" stroke-width="' + f(Math.max(1.2, R * 0.04)) + '"></line>' +
        '<circle class="at-wrist__cap" cx="' + cx + '" cy="' + cy + '" r="' + f(Math.max(1.8, R * 0.05)) + '"></circle>' +
        '<g class="at-wrist__dim">' +
        '<line x1="' + f(cx - R) + '" y1="' + f(yT) + '" x2="' + f(cx + R) + '" y2="' + f(yT) + '"></line>' +
        '<line x1="' + f(cx - R) + '" y1="' + f(yT - 4) + '" x2="' + f(cx - R) + '" y2="' + f(yT + 4) + '"></line>' +
        '<line x1="' + f(cx + R) + '" y1="' + f(yT - 4) + '" x2="' + f(cx + R) + '" y2="' + f(yT + 4) + '"></line>' +
        '<text x="' + cx + '" y="' + f(yT - 8) + '" text-anchor="middle">' + lc + '</text>' +
        '</g>' +
        '<g class="at-wrist__dim">' +
        '<line x1="340" y1="' + f(cy - a) + '" x2="340" y2="' + f(cy + a) + '"></line>' +
        '<line x1="336" y1="' + f(cy - a) + '" x2="344" y2="' + f(cy - a) + '"></line>' +
        '<line x1="336" y1="' + f(cy + a) + '" x2="344" y2="' + f(cy + a) + '"></line>' +
        '<text x="332" y="' + f(cy + 4) + '" text-anchor="end">' + lw + '</text>' +
        '</g>';
    },
    init: initWrist
  };

  function fmtNum(n, dec, digits) {
    var s = digits ? n.toFixed(digits) : String(Math.round(n));
    return dec && dec !== '.' ? s.replace('.', dec) : s;
  }

  function initWrist(root) {
    if (!root || root.__atWrist) return;
    root.__atWrist = true;
    var q = function (sel) { return root.querySelector(sel); };
    var inW = q('[data-at-wrist-w]'), inC = q('[data-at-wrist-c]');
    var outW = q('[data-at-wrist-w-out]'), outC = q('[data-at-wrist-c-out]');
    var svg = q('[data-at-wrist-svg]'), vEl = q('[data-at-wrist-verdict]'), nEl = q('[data-at-wrist-note]');
    var rEl = q('[data-at-wrist-range]'), mk = q('[data-at-wrist-marker]');
    var ds = root.dataset || {};
    var dec = ds.dec || ',';
    var uid = ds.uid || ('w' + Math.random().toString(36).slice(2, 8));
    var fixedC = WR.clampC(root.getAttribute('data-at-wrist-case'));
    var raf = 0, saveT = 0;

    var st = WR.load() || {};
    var cm = WR.clampW(st.w) || WR.clampW(inW && inW.value) || 17;
    var mm = fixedC || WR.clampC(st.c) || WR.clampC(inC && inC.value) || 40;
    if (inW) inW.value = cm;
    if (inC) { if (fixedC) inC.value = fixedC; else inC.value = mm; }

    function tpl(s, map) {
      return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
    }
    function paintRange(input) {
      if (!input) return;
      var min = parseFloat(input.min), max = parseFloat(input.max), v = parseFloat(input.value);
      input.style.setProperty('--p', (((v - min) / (max - min)) * 100).toFixed(1) + '%');
    }
    function render() {
      raf = 0;
      var v = WR.verdict(cm, mm), rg = WR.range(cm), r = WR.ratio(cm, mm);
      var wTxt = fmtNum(cm, dec, 1), wmm = Math.round(WR.width(cm));
      if (outW) outW.textContent = tpl(ds.tW || '{w} cm', { w: wTxt });
      if (outC) outC.textContent = tpl(ds.tC || '{c} mm', { c: mm });
      if (inW) { inW.setAttribute('aria-valuetext', tpl(ds.tW || '{w} cm', { w: wTxt })); paintRange(inW); }
      if (inC) { inC.setAttribute('aria-valuetext', tpl(ds.tC || '{c} mm', { c: mm })); paintRange(inC); }
      if (vEl) vEl.textContent = ds['v' + v.charAt(0).toUpperCase() + v.slice(1)] || v;
      if (nEl) nEl.textContent = ds['n' + v.charAt(0).toUpperCase() + v.slice(1)] || '';
      if (rEl) rEl.textContent = tpl(ds.tRange, { w: wTxt, min: rg[0], max: rg[1] });
      root.setAttribute('data-verdict', v);
      if (mk) {
        var p = Math.min(100, Math.max(0, (r - 0.45) / (0.95 - 0.45) * 100));
        mk.style.left = p.toFixed(1) + '%';
      }
      if (svg) {
        svg.innerHTML = WR.svg(cm, mm, uid, {
          c: tpl(ds.tC || '{c} mm', { c: mm }),
          w: tpl(ds.tWidth || '≈ {mm} mm', { mm: wmm })
        });
        if (ds.tAria) svg.setAttribute('aria-label', tpl(ds.tAria, { w: wTxt, c: mm }));
      }
    }
    function queue() {
      if (!raf) raf = (w.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); })(render);
    }
    function persist() {
      clearTimeout(saveT);
      saveT = setTimeout(function () {
        WR.save(fixedC ? { w: cm } : { w: cm, c: mm });
        try { d.dispatchEvent(new CustomEvent('at:wrist', { detail: { w: cm, c: fixedC ? null : mm, src: root } })); } catch (e) {}
      }, 250);
    }
    if (inW) inW.addEventListener('input', function () { cm = WR.clampW(inW.value) || cm; queue(); persist(); });
    if (inC && !fixedC) inC.addEventListener('input', function () { mm = WR.clampC(inC.value) || mm; queue(); persist(); });
    d.addEventListener('at:wrist', function (e) {
      var o = e.detail || {};
      if (o.src === root) return;
      if (o.w) { cm = o.w; if (inW) inW.value = cm; }
      if (o.c && !fixedC) { mm = o.c; if (inC) inC.value = mm; }
      queue();
    });
    w.addEventListener('storage', function (e) {
      if (e.key !== WR.KEY && e.key !== WR.KEY_CASE) return;
      var o = WR.load();
      if (!o) return;
      if (o.w) { cm = o.w; if (inW) inW.value = cm; }
      if (o.c && !fixedC) { mm = o.c; if (inC) inC.value = mm; }
      queue();
    });
    root.classList.add('is-ready');
    render();
  }

  function initWrists(root) {
    root = root && root.querySelectorAll ? root : d;
    toArray(root.querySelectorAll('[data-at-wrist-sim]')).forEach(initWrist);
  }


  /* 7 · Header navigation: disclosure dropdowns ---------------------------------------------------
     Markup (sections/header.liquid): li[data-at-nav-item] > a.at-nav__link + button[data-at-nav-toggle]
     (aria-expanded, aria-controls) + .at-nav__panel[data-at-nav-panel]. The top-level link always navigates;
     the toggle opens the panel (click / Enter / Space / ArrowDown). Hover opens with a short intent delay
     on fine pointers. Escape closes and returns focus to the toggle; focus leaving the item closes it. */
  var navOpen = null, navT = 0;
  var hoverMq = w.matchMedia ? w.matchMedia('(hover: hover) and (pointer: fine)') : null;
  function navSet(item, open, focusFirst) {
    if (!item) return;
    var btn = item.querySelector('[data-at-nav-toggle]');
    if (open) {
      if (navOpen && navOpen !== item) navSet(navOpen, false);
      item.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      navOpen = item;
      if (focusFirst) {
        var first = item.querySelector('[data-at-nav-panel] a');
        if (first) setTimeout(function () { first.focus(); }, 30);
      }
    } else {
      item.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (navOpen === item) navOpen = null;
    }
  }
  function initNav(root) {
    toArray((root || d).querySelectorAll('[data-at-nav-item]')).forEach(function (item) {
      if (item.__atNav) return;
      item.__atNav = true;
      var btn = item.querySelector('[data-at-nav-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        /* A panel opened by hover is "pinned" by the first click instead of being closed again. */
        if (item.classList.contains('is-open') && item.__atHover) { item.__atHover = false; return; }
        item.__atHover = false;
        navSet(item, !item.classList.contains('is-open'));
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); navSet(item, true, true); }
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          if (item.classList.contains('is-open')) { e.stopPropagation(); navSet(item, false); btn.focus(); }
          return;
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var links = toArray(item.querySelectorAll('[data-at-nav-panel] a'));
        var i = links.indexOf(d.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var n = e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : i - 1;
        if (n < 0) btn.focus(); else links[n].focus();
      });
      item.addEventListener('focusout', function (e) {
        if (e.relatedTarget && item.contains(e.relatedTarget)) return;
        setTimeout(function () { if (!item.contains(d.activeElement)) navSet(item, false); }, 0);
      });
      item.addEventListener('mouseenter', function () {
        if (!hoverMq || !hoverMq.matches) return;
        clearTimeout(navT);
        navT = setTimeout(function () {
          if (!item.classList.contains('is-open')) item.__atHover = true;
          navSet(item, true);
        }, navOpen ? 0 : 90);
      });
      item.addEventListener('mouseleave', function () {
        if (!hoverMq || !hoverMq.matches) return;
        clearTimeout(navT);
        navT = setTimeout(function () { navSet(item, false); }, 160);
      });
    });
  }
  d.addEventListener('click', function (e) {
    if (navOpen && !navOpen.contains(e.target)) navSet(navOpen, false);
  });
  d.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && navOpen) navSet(navOpen, false);
  });

  /* 8 · Mobile drawer accordion: button[data-at-drawer-toggle][aria-controls] toggles its list (hidden). */
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-at-drawer-toggle]') : null;
    if (!b) return;
    e.preventDefault();
    var p = d.getElementById(b.getAttribute('aria-controls'));
    var open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!p) return;
    p.hidden = !open;
    if (open && !reduced() && p.animate) {
      p.animate([{ opacity: 0, transform: 'translate3d(0,-4px,0)' }, { opacity: 1, transform: 'none' }], { duration: 220, easing: EASE });
    }
  });

  /* 9 · Language / country panel (snippets/at-localization, header): [data-at-loc] > [data-at-loc-toggle] + [data-at-loc-panel].
     Options are submit buttons, so the panel only needs open/close. */
  function locSet(wrap, open) {
    var t = wrap.querySelector('[data-at-loc-toggle]'), p = wrap.querySelector('[data-at-loc-panel]');
    if (!t || !p) return;
    p.hidden = !open;
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    wrap.classList.toggle('is-open', open);
  }
  d.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-at-loc-toggle]') : null;
    toArray(d.querySelectorAll('[data-at-loc].is-open')).forEach(function (w0) {
      if (!w0.contains(e.target)) locSet(w0, false);
    });
    if (!t) return;
    e.preventDefault();
    var wrap = t.closest('[data-at-loc]');
    locSet(wrap, t.getAttribute('aria-expanded') !== 'true');
    if (wrap.classList.contains('is-open')) {
      var cur = wrap.querySelector('[data-at-loc-panel] [aria-current="true"]') || wrap.querySelector('[data-at-loc-panel] button');
      if (cur) setTimeout(function () { cur.focus(); }, 30);
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    toArray(d.querySelectorAll('[data-at-loc].is-open')).forEach(function (w0) {
      locSet(w0, false);
      var t = w0.querySelector('[data-at-loc-toggle]');
      if (t) t.focus();
    });
  });
  d.addEventListener('focusout', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest('[data-at-loc].is-open') : null;
    if (!wrap) return;
    setTimeout(function () { if (!wrap.contains(d.activeElement)) locSet(wrap, false); }, 0);
  });

  /* 10 · Cart order links (snippet at-cart-cta): keep the prefilled WhatsApp text / e-mail body in sync
     with the live cart. [data-at-cart-order="wa"|"mail"]; texts come from data attributes (trilingual). */
  function moneyFmt(sample) {
    var m = String(sample || '').match(/^([^\d]*)(\d[\d.,'\s  ’]*\d)(.*)$/);
    if (!m) return null;
    var pre = m[1], num = m[2], suf = m[3], digits = num.replace(/\D/g, ''), dec = 0, decSep = '', thSep = '';
    if (digits === '1234567') { dec = 2; decSep = num.charAt(num.length - 3); }
    else if (digits !== '12346' && digits !== '12345') return null;
    var c2 = num.charAt(2);
    if (!/\d/.test(c2)) thSep = c2;
    return function (cents) {
      var c = Math.abs(Number(cents) || 0);
      var v = dec ? (c / 100).toFixed(2) : String(Math.round(c / 100));
      var parts = v.split('.');
      var ip = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thSep);
      return (Number(cents) < 0 ? '-' : '') + pre + ip + (dec ? decSep + parts[1] : '') + suf;
    };
  }
  function buildOrderLinks(cart) {
    var items = (cart && cart.items) || [];
    toArray(d.querySelectorAll('[data-at-cart-order]')).forEach(function (a) {
      var kind = a.getAttribute('data-at-cart-order');
      if (kind === 'mail') {
        var lines = items.map(function (it) {
          var v = (it.variant_title && !it.product_has_only_default_variant) ? ' – ' + it.variant_title : '';
          return '- ' + it.product_title + v + ' × ' + it.quantity;
        });
        var body = a.getAttribute('data-at-greet') + '\n\n' + a.getAttribute('data-at-intro') + '\n\n' + lines.join('\n') + '\n\n' + a.getAttribute('data-at-close');
        a.setAttribute('href', 'mailto:' + a.getAttribute('data-at-email') + '?subject=' + encodeURIComponent(a.getAttribute('data-at-subject')) + '&body=' + encodeURIComponent(body));
      } else if (kind === 'wa') {
        var fmt = moneyFmt(a.getAttribute('data-money')) || function (c) { return (c / 100).toFixed(2); };
        var origin = a.getAttribute('data-origin') || w.location.origin;
        var out = [a.getAttribute('data-hi')];
        items.forEach(function (it) {
          var v = (it.variant_title && !it.product_has_only_default_variant) ? ' – ' + it.variant_title : '';
          var sku = it.sku ? ' (SKU ' + it.sku + ')' : '';
          out.push('• ' + it.product_title + v + sku + ' · ' + a.getAttribute('data-q') + ': ' + it.quantity + ' · ' + fmt(it.final_line_price));
          out.push('  ' + origin + it.url);
        });
        out.push(a.getAttribute('data-total') + ': ' + fmt(cart.total_price));
        out.push('', a.getAttribute('data-me'));
        (a.getAttribute('data-fields') || '').split('|').forEach(function (f) { if (f) out.push(f); });
        out.push('', a.getAttribute('data-pay'));
        a.setAttribute('href', 'https://wa.me/' + a.getAttribute('data-phone') + '?text=' + encodeURIComponent(out.join('\n')));
      }
    });
  }
  var orderT = 0;
  function refreshOrderLinks() {
    if (!d.querySelector('[data-at-cart-order]')) return;
    clearTimeout(orderT);
    orderT = setTimeout(function () {
      var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(buildOrderLinks).catch(function () {});
    }, 250);
  }
  ['cart:updated', 'cart:build', 'cart:refresh', 'ajaxCart:updated', 'ajaxProduct:added', 'drawerOpen.CartDrawer'].forEach(function (ev) {
    d.addEventListener(ev, refreshOrderLinks);
  });
  function watchCart() {
    if (!w.MutationObserver) return;
    toArray(d.querySelectorAll('#CartDrawer [data-products], #CartPageForm [data-products]')).forEach(function (el) {
      new MutationObserver(refreshOrderLinks).observe(el, { childList: true, subtree: true });
    });
  }

  /* 5 · Theme editor -------------------------------------------------------------------------- */
  function onSectionLoad(e) { reveal(e.target); initWrists(e.target); initNav(e.target); }
  function onBlockSelect(e) {
    var t = e.target;
    var sec = t && t.closest ? t.closest('.shopify-section') : null;
    revealNow(sec || t);
  }

  function init() {
    injectRevealCss();
    reveal(d);
    initWrists(d);
    initNav(d);
    watchCart();
    measure();
  }

  w.addEventListener('scroll', onScroll, { passive: true });
  d.addEventListener('click', onAccClick);
  d.addEventListener('shopify:section:load', onSectionLoad);
  d.addEventListener('shopify:block:select', onBlockSelect);
  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', onMotionChange);
    else if (mq.addListener) mq.addListener(onMotionChange);
  }

  /* 6 · Public API */
  w.SWAT = w.SWAT || {};
  w.SWAT.reveal = reveal;
  w.SWAT.wrist = WR;
  w.SWAT.nav = { set: navSet, init: initNav };
  w.SWAT.cartOrder = refreshOrderLinks;

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();